module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-3-f286e7393a74ec89b2dd437a29a9e60d.svg";